// import axios from "axios";

export const PROFILE_URL =
  "data:image/jpeg;base64,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";

const fetchImageFromUri = async (ImageUri) => {
  const response = await fetch(ImageUri);
  const blob = await response.blob();
  return blob;
};

const profileImageUploadReq = async (image, signedUrl) => {
  try {
    const imageBlob = await fetchImageFromUri(image);

    const response = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/octet-stream",
      },
      body: imageBlob,
    });

    if (!response.ok) {
      throw new Error("Error uploading image. Please try again!");
    }
    return response;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
};

// const profileImageUploadReq = async (image, signedUrl) => {
//   try {
//     const imageBlob = fetchImageFromUrl(image);

//     const config = {
//       headers: {
//         "Content-Type": "application/octet-stream",
//       },
//     };

//     const data = await axios.put(signedUrl, imageBlob, config);
//     console.log(data);
//     return data;
//   } catch (err) {
//     console.error(err);
//   }
// };

export default profileImageUploadReq;
